export default "__VITE_ASSET__Bg8C8cVT__"